import React from "react";
import { PERSONAL, SOCIAL_LINKS } from "../../data";
import type { SocialLink } from "../../types";
import { Reveal } from "../ui/Reveal";

// ── Sub-components ────────────────────────────────────────────────────────────

interface SocialLinkCardProps {
  link: SocialLink;
}

const SocialLinkCard: React.FC<SocialLinkCardProps> = ({ link }) => (
  <a
    href={link.href}
    className="social-link"
    target={link.href.startsWith("http") ? "_blank" : undefined}
    rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
    aria-label={`${link.name}: ${link.handle}`}
  >
    <div className="social-icon" aria-hidden="true">
      {link.icon}
    </div>
    <div>
      <span className="social-name">{link.name}</span>
      <span className="social-handle">{link.handle}</span>
    </div>
  </a>
);

const AvailabilityCard: React.FC = () => (
  <div className="contact-availability">
    <div className="avail-label">Current Status</div>
    <div className="avail-title">Open to new opportunities</div>
    <div className="avail-sub">
      Actively looking for full-time software engineering roles in Tasmania or
      remote. Interested in ambitious teams building meaningful products.
    </div>
    <div className="avail-badge">Available now</div>
  </div>
);

// ── Main component ─────────────────────────────────────────────────────────────

export const Contact: React.FC = () => (
  <section id="contact">
    <div className="section-wrap">
      <div className="contact-grid">
        {/* ── Left — contact details ── */}
        <Reveal>
          <div className="sec-label">Contact</div>
          <h2 className="sec-title" style={{ marginBottom: "1.5rem" }}>
            Let's build <em>something.</em>
          </h2>

          <p className="contact-intro">
            Open to full-time roles, contract work, and interesting side
            projects. I respond promptly — drop me a line any time.
          </p>

          <a href={`mailto:${PERSONAL.email}`} className="contact-email-link">
            {PERSONAL.email}
          </a>

          <div className="contact-socials">
            {SOCIAL_LINKS.map((link) => (
              <SocialLinkCard key={link.name} link={link} />
            ))}
          </div>
        </Reveal>

        {/* ── Right — availability card ── */}
        <Reveal delay={120}>
          <AvailabilityCard />
        </Reveal>
      </div>
    </div>
  </section>
);
